import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { setupExternalSvgHydrator } from '@core/utils/external-svg-hydrator';

bootstrapApplication(App, appConfig)
  .then(() => {
    setupExternalSvgHydrator();
  })
  .catch((err) => {
    // Bootstrap провалился (Keycloak недоступен, сеть, JS-ошибка). Перепишем
    // fallback-блок из index.html на читаемое сообщение, чтобы пользователь
    // не остался с пустым экраном.
    console.error('Bootstrap failed:', err);
    const msgEl = document.getElementById('bootstrap-fallback-msg');
    if (msgEl) {
      msgEl.textContent =
        'Не удалось запустить приложение. Проверьте подключение и перезагрузите страницу.';
    }
    const titleEl = document.querySelector<HTMLElement>('#bootstrap-fallback > div:first-child');
    if (titleEl) {
      titleEl.textContent = 'Ошибка запуска';
      titleEl.style.color = '#c53030';
    }
  });
